import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import NumberFormat from 'react-number-format';

export const MontosAPagar = ({ dataForm, handleItemSelected }) => {
    // const [cantDecimales, setCantDecimales] = useState(2)
    const cantDecimales = 2

    const { local_simbolo, local_separacion_miles, local_separacion_decimales } = useSelector(state => state.general.info)

    const [detIsPay, setDetIsPay] = useState(false)
    const [totalProvIsPay, setTotalProvIsPay] = useState(false)
    const [netoIsPay, setNetoIsPay] = useState(false)
    const [igvIsPay, setIgvIsPay] = useState(false)

    const {
        separacion_miles,
        separacion_decimales,
        simbolo,
        monto_base,
        total_impuesto,
        total_compra,
        // total_cobrado,
        // total_por_cobrar,
        // aplica_detraccion,
        porcentaje_detraccion = 12,
        total_detraccion,
        total_por_pagar,
        total_pagado,
        // id_moneda,
        pays
    } = dataForm

    const checkIsPay = useCallback(() => {

        setDetIsPay(false)
        setTotalProvIsPay(false)
        setNetoIsPay(false)
        setIgvIsPay(false)

        for (let x = 0; x < pays.length; x++) {
            const pay = pays[x]

            const filtered1 = pay.ids_item_compra.filter((it) => it.from === 'detraccion')
            if (filtered1.length > 0) {
                setDetIsPay(true)
            }

            const filtered2 = pay.ids_item_compra.filter((it) => it.from === 'neto+igv')
            if (filtered2.length > 0) {
                setTotalProvIsPay(true)
            }

            const filtered3 = pay.ids_item_compra.filter((it) => it.from === 'neto')
            if (filtered3.length > 0) {
                setNetoIsPay(true)
            }

            const filtered4 = pay.ids_item_compra.filter((it) => it.from === 'igv')
            if (filtered4.length > 0) {
                setIgvIsPay(true)
            }

        }

    }, [pays])

    useEffect(() => {
        checkIsPay()
    }, [pays, total_pagado, checkIsPay])

    return (
        <>
            <div className='p-compras-box-totales-cobro mt-2'>

                <div className="grid grid-cols-3 gap-4 mt-3">
                    <h5 className='text-[13px] font-bold text-[#595759]'>Desglose a pagar</h5>
                    <h5 className='text-[13px] font-bold text-[#595759] text-end'>Monto</h5>
                    <h5 className='text-[13px] font-bold text-[#595759] text-end'>Seleccionar para pagar</h5>
                </div>

                <div className="grid grid-cols-3 gap-4 mt-3">
                    <div className='text-start'>
                        <span className='content-center'>Detracción {porcentaje_detraccion || 12}% ( deposito BN )</span>
                    </div>
                    <div className='text-end font-bold text-[#595759] content-center'>
                        <NumberFormat
                            value={parseFloat(total_detraccion || 0)}
                            displayType={'text'}
                            thousandSeparator={local_separacion_miles}
                            decimalSeparator={local_separacion_decimales}
                            prefix={`${local_simbolo} `}
                            decimalScale={cantDecimales}
                            fixedDecimalScale
                        />
                    </div>
                    <div className='text-end content-center'>
                        {detIsPay ?
                            <span className='me-[35px] mt-1' style={{ color: 'green' }}>
                                Pagada
                                <i className="bi bi-check-lg"></i>
                            </span>
                            :
                            <input
                                className='p-normal-checkbox me-5 mt-1'
                                type="checkbox"
                                onChange={(e) => handleItemSelected(e, { monto: parseFloat(total_detraccion || 0) }, 'detraccion')}
                            />
                        }
                    </div>
                </div>

                {/* if (netoIsPay || igvIsPay) {
                    setTotalProvIsPay(true)
                } */}

                <div className="grid grid-cols-3 gap-4 mt-2">
                    <div className='text-start'>
                        <span>A cuenta del proveedor</span>
                    </div>
                    <div className='text-end font-bold text-[#595759]'>
                        <NumberFormat
                            value={parseFloat(total_compra) - parseFloat(total_detraccion)}
                            displayType={'text'}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={cantDecimales}
                            fixedDecimalScale
                        />
                    </div>
                    <div className='text-end content-center'>
                        {totalProvIsPay ?
                            <span className='me-[35px] mt-1' style={{ color: 'green' }}>
                                Pagada
                                <i className="bi bi-check-lg"></i>
                            </span>
                            :
                            <input
                                className='p-normal-checkbox me-5 mt-0'
                                type="checkbox"
                                onChange={(e) => handleItemSelected(e, { monto: parseFloat(total_compra) - parseFloat(total_detraccion) }, 'neto+igv')}
                                disabled={(netoIsPay || igvIsPay || (total_por_pagar === 0))}
                            />
                        }
                    </div>
                </div>

                <div className="grid grid-cols-3 gap-4 mt-2">
                    <div className='text-start'>
                        <i className="bi bi-arrow-return-right"></i>
                        <span className='ms-1'>Monto neto</span>
                    </div>
                    <div className='text-end'>
                        <NumberFormat
                            value={parseFloat(monto_base)}
                            displayType={'text'}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                    </div>
                    <div className='text-end'>
                        {netoIsPay ?
                            <span className='me-[35px] mt-1' style={{ color: 'green' }}>
                                Pagada
                                <i className="bi bi-check-lg"></i>
                            </span>
                            :
                            <input
                                className='p-normal-checkbox me-5 mt-0'
                                type="checkbox"
                                onChange={(e) => handleItemSelected(e, { monto: parseFloat(monto_base) }, 'neto')}
                                disabled={(totalProvIsPay || (total_por_pagar === 0))}
                            />
                        }
                    </div>
                </div>

                <div className="grid grid-cols-3 gap-4 mt-2">
                    <div className='text-start'>
                        <i className="bi bi-arrow-return-right"></i>
                        <span className='ms-1'>Diferencia IGV {18 - porcentaje_detraccion}%</span>
                    </div>
                    <div className='text-end'>
                        <NumberFormat
                            value={parseFloat(total_impuesto) - parseFloat(total_detraccion)}
                            displayType={'text'}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                    </div>
                    <div className='text-end'>
                        {igvIsPay ?
                            <span className='me-[35px] mt-1' style={{ color: 'green' }}>
                                Pagada
                                <i className="bi bi-check-lg"></i>
                            </span>
                            :
                            <input
                                className='p-normal-checkbox me-5 mt-0'
                                type="checkbox"
                                onChange={(e) => handleItemSelected(e, { monto: parseFloat(total_impuesto) - parseFloat(total_detraccion) }, 'igv')}
                            />
                        }
                    </div>
                </div>

            </div>

            <div className='p-compras-box-totales-cobro mt-2'>

                <div className="grid grid-cols-3 gap-4 mt-3">
                    <h5 className='text-[13px] font-bold text-[#595759] text-start'>Resumen pagos</h5>
                    {/* <h5 className='text-[13px] font-bold text-[#595759] text-end'></h5> */}
                    <span></span>
                    <div></div>
                </div>

                <div className="grid grid-cols-3 gap-4 mt-3">
                    <div className='text-start'>
                        <span className='content-center'>Total pagado</span>
                    </div>
                    <div className='text-end font-bold text-[#595759] content-center'>
                        <NumberFormat
                            value={parseFloat(total_pagado)}
                            displayType={'text'}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={cantDecimales}
                            fixedDecimalScale
                        />
                    </div>
                    <div></div>
                </div>

                <div className="grid grid-cols-3 gap-4 mt-3">
                    <div className='text-start'>
                        <span className='content-center'>Por pagar</span>
                    </div>
                    <div className='text-end font-bold text-[#595759] content-center'>
                        <NumberFormat
                            value={parseFloat(total_por_pagar)}
                            displayType={'text'}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={cantDecimales}
                            fixedDecimalScale
                        />
                    </div>
                    <div></div>
                </div>

            </div>
        </>

    )
}